// pages/Dashboard.jsx
import BestReadsBooks from "../../components/home/BestReadsBooks";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <BestReadsBooks />
    </HomeLayout>
  );
}
